import request from '@/utils/request'


// 查询客服分组列表
export function listCustomerGroup(query) {
  return request({
    url: '/biz/admin/customer/group/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

export function selectCustomerGroup(query) {
  return request({
    url: '/biz/admin/customer/group/select',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}


// 查询客服分组分页
export function pageCustomerGroup(query) {
  return request({
    url: '/biz/admin/customer/group/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询客服分组详细
export function getCustomerGroup(data) {
  return request({
    url: '/biz/admin/customer/group/detail',
    method: 'get',
    params: data
  })
}

// 新增客服分组
export function addCustomerGroup(data) {
  return request({
    url: '/biz/admin/customer/group/add',
    method: 'post',
    data: data
  })
}

// 修改客服分组
export function updateCustomerGroup(data) {
  return request({
    url: '/biz/admin/customer/group/edit',
    method: 'post',
    data: data
  })
}

// 删除客服分组
export function delCustomerGroup(data) {
  return request({
    url: '/biz/admin/customer/group/delete',
    method: 'post',
    data: data
  })
}
